import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '@/models';
import { signIn, signInWithGoogle, signOut } from './actions';

export interface AuthState {
  user: User | null;
  signInError: string | null;
  signOutError: string | null;
  isLoading: boolean;
}

const initialState: AuthState = {
  user: null,
  signInError: null,
  signOutError: null,
  isLoading: true
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setSignInError: (state, action) => {
      state.signInError = action.payload;
    },
    setSignOutError: (state, action) => {
      state.signOutError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(signInWithGoogle.pending, (state) => {
        state.signInError = null;
      })
      .addCase(signInWithGoogle.rejected, (state, action) => {
        state.signInError = action.payload ?? null;
      })
      .addCase(signIn.pending, (state) => {
        state.isLoading = true;
        state.signInError = null;
      })
      .addCase(signIn.fulfilled, (state, action: PayloadAction<User>) => {
        state.user = action.payload;
        state.signInError = null;
        state.isLoading = false;
      })
      .addCase(signIn.rejected, (state, action: PayloadAction<string | undefined>) => {
        state.signInError = action.payload as string;
        state.isLoading = false;
      })
      .addCase(signOut.pending, (state) => {
        state.isLoading = true;
        state.signOutError = null;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.user = null;
        state.isLoading = false;
        state.signOutError = null;
      })
      .addCase(signOut.rejected, (state, action: PayloadAction<string | undefined>) => {
        state.signOutError = action.payload as string;
        state.isLoading = false;
      });
  }
});

export const { setUser, setSignInError, setSignOutError } = authSlice.actions;

export default authSlice.reducer;
